import { render, staticRenderFns } from "./ChatImageAdmin.vue?vue&type=template&id=9d825dc4&"
import script from "./ChatImageAdmin.vue?vue&type=script&lang=js&"
export * from "./ChatImageAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports